import { render } from "./ConfigurationRestoreEmptyDialog.vue?vue&type=template&id=c1d09610"
import script from "./ConfigurationRestoreEmptyDialog.vue?vue&type=script&lang=js"
export * from "./ConfigurationRestoreEmptyDialog.vue?vue&type=script&lang=js"

import "./ConfigurationRestoreEmptyDialog.vue?vue&type=style&index=0&id=c1d09610&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard});qInstall(script, 'directives', {ClosePopup});
